import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IModifierGroupContext, ModifierGroupContext } from '../../../../../modifierGroupState/modifierGroupContext';
import style from './DropdownMenu.module.scss';

export const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IModifierGroupContext>(ModifierGroupContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByModifierGroupLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByModifierGroupA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('ModifierGroupsA-Z')}
						checked={sortBy === 'ModifierGroupsA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByModifierGroupZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('ModifierGroupsZ-A')}
						checked={sortBy === 'ModifierGroupsZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};
